<template>
    <div
        :data-component-name="$options.name"
    >
        <div class="c-user-avatar__wrap"
            :class="classes"
        >
            <div
                class="c-user-avatar"
                :style="'background-color:'+avatarColor+'; color:'+textcolorComp+';'"
            >
                <div class="-content">
                    <span v-if="recipients.length<=1 && userInitials && userInitials!=''">
                        {{ userInitials }}
                    </span>
                    <!-- <span v-if="recipients.length>0">
                        {{ recipients.length }}
                    </span> -->
                    <q-icon class="o-avatar-icon" :name="icon" v-if="icon"
                    />
                    <q-icon 
                        v-if="recipients.length>1"
                        class="o-avatar-icon" name="people"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {hexColorFromString} from '@/js/utilities'

    export default {
        name: 'UserAvatar',
        props: {
            userProfileID:{
                type: Number,
                default: null,
            },
            recipients:{
                type: Array,
                default(){
                    return [];
                },
            },
            name:{
                type: String,
                default: null,
            },
            email:{
                type: String,
                default: null,
            },
            initials:{
                type: String,
                default: null,
            },
            icon:{
                type: String,
                default: null,
            },
            avatar: {
                type: String,
                default: null
            },
            color: {
                type: String,
                default: null
            },
            textcolor: {
                type: String,
                default: null
            },
            size: {
                type: String,
                default: ''
            }
        },
        //data(){
        //	return {
        //	}
        //},
        //mounted(){},
        computed: {
            classes(){
                if(this.recipients.length>1) return '-'+this.size+' -multiple-users';
                return '-'+this.size;
            },
            userInitials(){
                if(this.initials) return this.initials
                if(this.name){
                    let initials = [...this.name.matchAll(new RegExp(/(\p{L}{1})\p{L}+/, 'gu'))] || [];
                    return (
                        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
                    ).toUpperCase();
                }
                return null
            },
            avatarColor(){
                if(this.color) return this.color;
                if(this.email){
                    return hexColorFromString(this.email)
                }
                if(this.name){
                    return hexColorFromString(this.name)
                }

                return null
            },
            textcolorComp(){
                if(this.textcolor) return this.textcolor
                if(this.avatarColor){
                    return this.invertColor(this.avatarColor, true)
                }
                return null;
            }
        },
        //watch: {},
        methods: {
            lpad(str, size=2){
                var s = String(str);
                while (s.length < (size || 2)) {s = "0" + s;}
                return s;
            },
            invertColor(hex, bw) {
                if (hex.indexOf('#') === 0) {
                    hex = hex.slice(1);
                }
                // convert 3-digit hex to 6-digits.
                if (hex.length === 3) {
                    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                }
                if (hex.length !== 6) {
                    throw new Error('Invalid HEX color.');
                }
                let r = parseInt(hex.slice(0, 2), 16),
                    g = parseInt(hex.slice(2, 4), 16),
                    b = parseInt(hex.slice(4, 6), 16);
                if (bw) {
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 150 //186
                        ? '#000000'
                        : '#FFFFFF';
                }
                // invert color components
                r = (255 - r).toString(16);
                g = (255 - g).toString(16);
                b = (255 - b).toString(16);
                // pad each with zeros and return
                return "#" + this.lpad(r) + this.lpad(g) + this.lpad(b);
            }

        },
    }
</script>